import React from 'react';

const WelcomeView = () => {

    return <>
        Hello
    </>
}

export default WelcomeView;